import IComp from '@/models/Comp';

export default interface IRunFieldPrefsRequest {
    comp: IComp;
    overrideSourceInitial: boolean;
}

/**
 * Convenience method for getting a new request. Override source initial is false.
 * @param comp
 * @returns
 */
export function newRunFieldPrefsRequest(comp: IComp): IRunFieldPrefsRequest {
    const request: IRunFieldPrefsRequest = {
        comp: comp,
        overrideSourceInitial: false
    };
    return request;
}
